import React from "react";
import { Sparkles } from "lucide-react";
import { fmtUS } from "@/lib/api";

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
const TONES = ["bg-[#E8F8EF] text-[#15803D] border-[#BBF7D0]", "bg-[#EAF4FF] text-[#1D4ED8] border-[#BFDBFE]", "bg-[#F3E8FF] text-[#7E22CE] border-[#E9D5FF]"];

export function PrepBadge({ start, year, testid }) {
  if (!start || !year || String(start).slice(0, 4) !== String(year)) return null;
  const m = Number(start.slice(5, 7)) - 1;
  return (
    <span title={`PrEP Initiated: ${fmtUS(start)}`} data-testid={testid}
      className={`inline-flex items-center gap-1 whitespace-nowrap rounded-full border px-1.5 py-px text-[10px] font-semibold leading-4 ${TONES[Math.floor(m / 4)]}`}>
      <Sparkles size={9} />New PrEP — {MONTHS[m]} {year}
    </span>
  );
}
